import { createRouter, createWebHistory } from 'vue-router';
// import AboutMeView from '../components/AboutMeView.vue';
import CVView from '../components/CVView.vue';
import HomeView from '../components/HomeView.vue';
// import ArtHomeView from '@/components/Art/ArtHomeView.vue';
import NerdyView from '@/components/Art/Categories/NerdyView.vue';
import GeometricWorldsView from '@/components/Art/Categories/GeometricWorldsView.vue';
import ArtHomeView from '@/components/Art/ArtHomeView.vue';

import TdHomeView from '@/components/Td/TdHomeView.vue';
import DataVisualizationView from '@/components/Td/projects/DataVisualizationView.vue';
import VisualsVJView from '@/components/Td/projects/VisualsVJView.vue';
import GeographicDataView from '@/components/Td/projects/GeographicDataView.vue';
import OtherView from '@/components/Td/projects/OtherView.vue';

const routes = [
    {
        path: '/',
        name: 'Home-View',
        component: HomeView,    
    },  
    {
        path: '/cv',
        name: 'CV-View',
        component: CVView,
    },
    {
        path: '/art',
        name: 'art',
        component: ArtHomeView,
    },
    {
        path: '/art/nerdy',
        name: 'Nerdy-View',
        component: NerdyView,
    },
    {
        path: '/art/geometric-worlds',
        name: 'GeometricWorlds-View',
        component: GeometricWorldsView,
    }, 
    { 
        path: '/td', 
        name: 'TdHome-View',
        component: TdHomeView,
    },
    { 
        path: '/td/dataviz', 
        name: 'data-viz',
        component: DataVisualizationView,
    },
    { 
        path: '/td/visuals', 
        name: 'visuals',
        component: VisualsVJView,
    },   
    { 
        path: '/td/geo-data', 
        name: 'geo-data',
        component: GeographicDataView,
    },   
    { 
        path: '/td/other', 
        name: 'other',
        component: OtherView,
    },   
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
